import React from 'react'

export default class Contact extends React.Component {
    render() {
        return (
            <div className="ContactBar">
                Are you listening?  Let me know: 8ziuopt0@anonaddy.com
            </div>
        )
    }
}
